import React, { Component, Fragment } from "react";
import Select from "react-select";
import { Link } from "react-router-dom";
import Header from "../Header";
import { list as industryList } from "../../../services/industry";
import { list as jobDurationList } from "../../../services/jobDuration";
import { list as jobCategoryList } from "../../../services/jobCategory";
import { list as typeList } from "../../../services/jobType";
import { list as empList} from "../../../services/employer";
import { list as skillList } from "../../../services/skill";
import { list as jobNicheList } from "../../../services/jobNiche";
import { record, update } from "../../../services/adminJobListing";
import "react-quill/dist/quill.snow.css";
import Quill from "react-quill";
import AppContext from "../../../contexts/AppContext";

import Waiting from "../../utilities/Waiting";

export class JobUpdate extends Component {
    state = {
        item: {
            industry_id: [],
            category_id: [],
            skill_id: [],
            jobNiche_id: [],
            employer_details: []
        },
        errors: {},
        state: "",
        industryList: [],
        jobCategoryList: [],
        skillList: [],
        jobNicheList: [],
        typeList: [],
        jobDurationList: [],
        card: [],
        needPayment: false,
        needCard: false,
        paymentCompleted: false,
        needCoupon: false,
        waiting: true,
        jobSourceList:[],
        empLocationList: [],
        empSourceList:[],
        addExternalEmployerLink: true,
        createM : false,        
        selectedemp : 'Select',
        spotList: [],
        category_id_details: [],
        industry_id_details: [],
        skill_id_details: [],
        topic_id_details: []
    };

    onChange = field => {
        let temp = this.state.item;
        temp[field.target.name] = field.target.value;       
        let error = this.state.errors;
        error[field.target.name] = null;   
        if(field.target.name == 'payout')
        {
            this.state.item.payout = parseFloat(field.target.value).toFixed(2);
        }

        this.setState({ item: temp, errors: error });
    };

    handleQuillChange = value => {
        let temp = this.state.item;
        temp.description = value;

        let error = this.state.errors;
        error.description = null;

        this.setState({ item: temp, errors: error });
    };

    handleIndustrySelectChange = selectedOption => {
        console.log(selectedOption)
        let temp = this.state.item;

        if (selectedOption !== null && selectedOption.length > 0) {
            temp.industry_id = [];
            selectedOption.forEach(function (item, index) {
                temp.industry_id[index] = {};
                temp.industry_id[index]['industry_id'] = item.value;
            });
        } else {
            temp.industry_id = [];
        }

        let error = this.state.errors;
        error.industry_id = null;

        this.setState({ item: temp, errors: error });
    };

    handleSkillSelectChange = selectedOption => {
        let temp = this.state.item;

        if (selectedOption !== null && selectedOption.length > 0) {
            temp.skill_id = [];
            selectedOption.forEach(function (item, index) {
                temp.skill_id[index] = {};
                temp.skill_id[index]['skill_id'] = item.value;
            });
        } else {
            temp.skill_id = [];
        }
        let error = this.state.errors;
        error.skill_id = null;

        this.setState({ item: temp, errors: error });
    };

    handleJobNicheSelectChange = selectedOption => {
        let temp = this.state.item;

        if (selectedOption !== null && selectedOption.length > 0) {
            temp.jobNiche_id = [];
            selectedOption.forEach(function (item, index) {
                temp.jobNiche_id[index] = {};
                temp.jobNiche_id[index]['topic_id'] = item.value;
            });
        } else {
            temp.jobNiche_id = [];
        }

        let error = this.state.errors;
        error.jobNiche_id = null;

        this.setState({ item: temp, errors: error });
    }

    handleCategorySelectChange = selectedOption => {
        let temp = this.state.item;

        if (selectedOption !== null && selectedOption.length > 0) {
            temp.category_id = [];
            selectedOption.forEach(function (item, index) {
                temp.category_id[index] = {};
                temp.category_id[index]['category_id'] = item.value;
            });
        } else {
            temp.category_id = [];
        }
        let error = this.state.errors;
        error.category_id = null;

        this.setState({ item: temp, errors: error });
    };

    handleDurationSelectChange = selectedOption => {
        let temp = this.state.item;
        temp.duration_id = selectedOption.value;

        let error = this.state.errors;
        error.duration_id = null;
        this.setState({ item: temp, errors: error });
    };

    handleTypeSelectChange = selectedOption => {
        let temp = this.state.item;
        temp.type_id = selectedOption.value;

        let error = this.state.errors;
        error.type_id = null;

        this.setState({ item: temp, errors: error });
    };

   
    handlespotChange = selectedOption => {
        let temp = this.state.item;
        temp.spots = selectedOption.value;

        let error = this.state.errors;
        error.spots = null;

        this.setState({ item: temp, errors: error });
    }

    handleempLocationChange = selectedOption => {
        let temp = this.state.item;
        temp.location = selectedOption.value;

        let error = this.state.errors;
        error.location = null;

        this.setState({ item: temp, errors: error });
    }

    handleValidation(){
        let fields = this.state.item;
        let errors = {};
        let formIsValid = true;
       console.log(this.state.item);
        if (this.state.addExternalEmployerLink == true)
        {
            if (!fields.employer_id || (this.state.item.employer_details == null) || (this.state.item.employer_details.state == 'deleted')) {
                formIsValid = false;
                errors.employer_id = "The select employer field is required.";
            }
            if(!fields.title){
                formIsValid = false;
                errors.title = "The title field is required.";
            }
            if(!fields.description){
                formIsValid = false;
                errors.description = "The description field is required.";
            }
            if(fields.industry_id.length == 0){
                formIsValid = false;
                errors.industry_id = "The industry field is required.";
            }
            if(!fields.source_url){
                formIsValid = false;
                errors.source_url = "The source url field is required.";
            }
            if(fields.source_url && !(fields.source_url).match(/\(?(?:(http|https|ftp):\/\/)?(?:((?:[^\W\s]|\.|-|[:]{1})+)@{1})?((?:www.)?(?:[^\W\s]|\.|-)+[\.][^\W\s]{2,4}|localhost(?=\/)|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})(?::(\d*))?([\/]?[^\s\?]*[\/]{1})*(?:\/?([^\s\n\?\[\]\{\}\#]*(?:(?=\.)){1}|[^\s\n\?\[\]\{\}\.\#]*)?([\.]{1}[^\s\?\#]*)?)?(?:\?{1}([^\s\n\#\[\]]*))?([\#][^\s\n]*)?\)?/g))
            {
                formIsValid = false;
                errors.source_url = "Please enter valid source url.";
            }
        }else{
            if (!fields.employer_id || (this.state.item.employer_details == null) || (this.state.item.employer_details.state == 'deleted')) {
                formIsValid = false;
                errors.employer_id = "The select employer field is required.";
            } 
            if(!fields.title){
                formIsValid = false;
                errors.title = "The title field is required.";
            }
            if(!fields.description){
                formIsValid = false;
                errors.description = "The description field is required.";
            }
            if(!fields.payout){
                formIsValid = false;
                errors.payout = "The payout field is required.";
            }
            if(fields.industry_id.length == 0){
                formIsValid = false;
                errors.industry_id = "The industry field is required.";
            }
            if(fields.category_id.length == 0){
                formIsValid = false;
                errors.category_id = "The writer role field is required.";
            }
            if(!fields.type_id){
                formIsValid = false;
                errors.type_id = "The employment type field is required.";
            }
            if(!fields.duration_id){
                formIsValid = false;
                errors.duration_id = "The employment duration field is required.";
            }
            if (!fields.spots) {
                formIsValid = false;
                errors.spots = "The spots field is required.";
            }
        }
        
        this.setState({errors: errors});
        return formIsValid;
    }

    handleSubmitJob = type => {
        if (this.handleValidation()) {
            update(this.props.match.params.id, { ...this.state.item, state: type })
                .then(response => {
                    this.context.state.updateUserPlan(response.meta.plan);
                    this.context.state.setCoupon({});
                    this.props.history.push("/admin/job-listings");
                })
                .catch(errors => {
                    switch (errors.response.status) {
                        case 422:
                            this.setState({ errors: errors.response.data.error });
                            break;
                        case 402:
                            this.setState({
                                needPayment: true,
                                needCard: false
                            });
                            break;
                        default:
                            this.context.state.handelError(errors);
                            break;
                    }
                });
        }
    };

    handleEmpSelectChange = selectedOption => {
        let temp = this.state.item;
        temp.employer_id = selectedOption.value;  
        temp.employer_details = {'id' : selectedOption.value, 'state': 'not-deleted'};
        this.state.selectedemp = selectedOption.name;      
        let error = this.state.errors;
        error.employer_id = null;        
        this.setState({ item: temp, errors: error });
    }

    handleJobSourceSelectChange = selectedOption => {
        let temp = this.state.item;
        temp.job_source = selectedOption.value;
        temp.employer_id = null;

        let error = this.state.errors;
        error.job_source = null;         
        this.state.selectedemp = 'Select';      
        this.setState({ item: temp, errors: error });  
        this.setState({selectedEmployer: []});  
        this.state.addExternalEmployerLink = (selectedOption.value == "external" ? true : false); 
        empList(selectedOption.value)
            .then(res => {
                this.setState({ empSourceList: res.data });
            })
            .catch(error => {
                this.setState({ empSourceList: [] });
                this.context.state.handelError(error);
        });
    }
    

    componentDidMount() {
        industryList()
            .then(res => {
                this.setState({ industryList: res.data });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
        jobCategoryList()
            .then(res => {
                this.setState({ jobCategoryList: res.data });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
        typeList()
            .then(res => {
                this.setState({ typeList: res.data });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
        jobDurationList()
            .then(res => {
                this.setState({ jobDurationList: res.data });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
        record(this.props.match.params.id)
            .then(response => {
                console.log(response);

                let industry_id_details = [];
                let category_id_details = [];
                let skill_id_details = [];
                let topic_id_details = [];
                
                response.data.industry.forEach(function (item, index) {
                    industry_id_details[index]= {};
                    industry_id_details[index]['industry_id'] = response.data.industry[index].industry_id;
                });

                response.data.category.forEach(function (item, index) {
                    category_id_details[index] = {};
                    category_id_details[index]['category_id'] = response.data.category[index].content_type_id;
                });
                response.data.skill.forEach(function (item, index) {
                    skill_id_details[index] = {};
                    skill_id_details[index]['skill_id'] = response.data.skill[index].skill_id;
                });
                response.data.topic.forEach(function (item, index) {
                    topic_id_details[index] = {};
                    topic_id_details[index]['topic_id'] = response.data.topic[index].topic_id;
                });
               
                
                this.setState({
                    item: {
                        job_source: response.data.job_type,
                        employer_id: response.data.user_id,
                        employer_details: response.data.user,
                        title : response.data.title,
                        description : response.data.description,
                        payout: response.data.payout,
                        word_count: response.data.word_count,
                        industry_id: industry_id_details,
                        category_id: category_id_details,
                        skill_id: skill_id_details,
                        jobNiche_id: topic_id_details,
                        type_id: response.data.type_id,
                        duration_id: response.data.duration_id,
                        source_url : response.data.source_url, 
                        location: response.data.location,
                        spots: response.data.spots, 

                    },
                    meta: response.meta,
                    waiting: false,
                    addExternalEmployerLink: (response.data.job_type == "external" ? true : false)
                });
               
                empList(this.state.item.job_source)
                    .then(res => {
                        this.setState({ empSourceList: res.data });
                    })
                    .catch(error => {
                        this.context.state.handelError(error);
                    })
            })
            .catch(error => {
                this.context.state.handelError(error);
            });

            
            skillList()
                .then(res => {
                    this.setState({ skillList: res.data });
                })
                .catch(error => {
                    this.context.state.handelError(error);
                });

            jobNicheList()
                .then(res => {
                    this.setState({ jobNicheList: res.data });
                })
                .catch(error => {
                    this.context.state.handelError(error);
                });

            this.setState({ jobSourceList: [
                {"id":'external',"value":'external',"name":'External Employer',"label":'External Employer'},
                {"id":'internal',"value":'internal',"name":'Internal Employer',"label":'Internal Employer'},
                
            ] });  
            
            this.setState({ empLocationList: [
                {"id":'remote',"value":'remote',"name":'Remote',"label":'Remote'},
                {"id":'onsite',"value":'onsite',"name":'On Site',"label":'On Site'},
                
            ] }); 
            const spots = [];
            for (let i = 1; i <= 20; i++) {
                spots.push(
                    {"id":i,"value":i,"name":i,"label":i}
                )
            }
           
            this.setState({ spotList: spots }); 
    }

    hideAll = () => {
        this.setState({
            needPayment: false,
            needCard: false,
            paymentCompleted: false,
            needCoupon: false
        });
    };

    render() {
        return (
            <Fragment>
                {this.state.waiting === true ? (
                    <Waiting></Waiting>
                ) : (
                    <Fragment>
                        <Header></Header>
                        <div className="main-content mt-6">
                            <div className="container mt-3">
                                <div className="row justify-content-center">
                                    <div
                                        id="formModal"
                                        className="col-12 col-lg-10 col-xl-8"
                                    >
                                        <div className="header">
                                            <div className="header-body">
                                                <div className="row align-items-center">
                                                    <div className="col">
                                                        <h6 className="header-pretitle">
                                                            Update job listing
                                                        </h6>
                                                        <h1 className="header-title">
                                                            Update job listing
                                                        </h1>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <form data-select2-id="14">
                                    <div className="form-group">
                                        <label htmlFor="job_source">Job Source</label>
                                        <Select defaultValue={{ label: "External Employer", value: "external" }}
                                                styles={{
                                                    control: base => ({
                                                        ...base,
                                                        "&:hover": {
                                                            borderColor:
                                                                "#1cd2ad",
                                                            boxShadow: "none"
                                                        },
                                                        "&": {
                                                            borderColor:
                                                                "#d2ddec",
                                                            boxShadow: "none"
                                                        }
                                                    }),
                                                    dropdownIndicator: base => ({
                                                        ...base,
                                                        color: "inherit"
                                                    }),
                                                    singleValue: base => ({
                                                        ...base,
                                                        color: "inherit"
                                                    })
                                                }}
                                                name="job_source"
                                                id="job_source"
                                                placeholder="Select"
                                                onChange={
                                                    this
                                                        .handleJobSourceSelectChange
                                                }
                                                value={this.state.jobSourceList.filter(
                                                    item => {
                                                        return (
                                                            item.id ===
                                                            this.state
                                                                .item
                                                                .job_source
                                                        );
                                                    }
                                                )}
                                                options={
                                                    this.state.jobSourceList
                                                }
                                            ></Select>
                                        {this.state.errors.job_source ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.job_source}
                                            </div>
                                        ) : null}
                                        
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="employer">Select Employer</label>
                                        <Select 
                                                styles={{
                                                    control: base => ({
                                                        ...base,
                                                        "&:hover": {
                                                            borderColor:
                                                                "#1cd2ad",
                                                            boxShadow: "none"
                                                        },
                                                        "&": {
                                                            borderColor:
                                                                "#d2ddec",
                                                            boxShadow: "none"
                                                        }
                                                    }),
                                                    dropdownIndicator: base => ({
                                                        ...base,
                                                        color: "inherit"
                                                    }),
                                                    singleValue: base => ({
                                                        ...base,
                                                        color: "inherit"
                                                    })
                                                }}
                                                name="employer_id"
                                                id="employer_id" 
                                                value={this.state.empSourceList.filter(
                                                    item => {
                                                        return (
                                                            item.id ===
                                                            this.state
                                                                .item
                                                                .employer_id
                                                        );
                                                    }
                                                )}
                                                  
                                                placeholder = {this.state.selectedemp}                                             
                                                onChange={
                                                    this
                                                        .handleEmpSelectChange
                                                }                                              
                                                options={
                                                    this.state.empSourceList
                                                }
                                            ></Select>
                                                    {this.state.errors.employer_id ? (
                                            <div className="invalid-feedback">
                                                 {this.state.errors.employer_id}
                                            </div>
                                        ) : null}
                                       
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="title">Title</label>
                                        <input
                                            id="title"
                                            name="title"
                                            onChange={this.onChange}
                                            value={this.state.item.title || '' }
                                            type="text"
                                            className="form-control"
                                        />
                                        {this.state.errors.title ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.title}
                                            </div>
                                        ) : null}
                                    </div>
                                    <div className="form-group mb-6">
                                        <label
                                            className="mb-1"
                                            htmlFor="description"
                                        >
                                            Job Description
                                        </label>
                                        <small className="form-text text-muted">
                                                Describe your writer, content, and employment requirements.
                                        </small>
                                        <Quill
                                            style={{
                                                height: "200px"
                                            }}
                                            value={
                                                this.state.item
                                                    .description || ""
                                            }
                                            onChange={this.handleQuillChange}
                                            
                                        ></Quill>

                                        {this.state.errors.description ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.description}
                                            </div>
                                        ) : null}
                                    </div>


                                    <div
                                        className="form-group mb-4"
                                        data-select2-id="12"
                                    >
                                        <label>Industries</label>
                                        <small className="form-text text-muted">What industries should the writer(s) have experience with?</small>
                                        <Select 
                                            styles={{
                                                control: base => ({
                                                    ...base,
                                                    "&:hover": {
                                                        borderColor:
                                                            "#1cd2ad",
                                                        boxShadow: "none"
                                                    },
                                                    "&": {
                                                        borderColor:
                                                            "#d2ddec",
                                                        boxShadow: "none"
                                                    }
                                                }),
                                                dropdownIndicator: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                }),
                                                singleValue: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                })
                                            }}
                                            name="industry_id"
                                            placeholder="Select"
                                            isMulti={true}

                                            value={this.state.industryList.filter(
                                                item => {
                                                    const temp = this.state.item.industry_id.map(
                                                        item => item.industry_id
                                                    );
                                                    return (
                                                        temp.indexOf(item.id) >= 0
                                                    );
                                                }
                                            )}

                                            onChange={
                                                this
                                                    .handleIndustrySelectChange
                                            }
                                            options={
                                                this.state.industryList
                                            }
                                        ></Select>
                                        {this.state.errors.industry_id ? (
                                            <div className="invalid-feedback">
                                                The industry field is
                                                required.
                                            </div>
                                        ) : null}
                                    </div>


                                    <div
                                        className="form-group mb-4"
                                        data-select2-id="12"
                                    >
                                        <label>Topics</label>
                                        <small className="form-text text-muted">What topics should the writer(s) have interest in?</small>
                                        <Select
                                            styles={{
                                                control: base => ({
                                                    ...base,
                                                    "&:hover": {
                                                        borderColor:
                                                            "#1cd2ad",
                                                        boxShadow: "none"
                                                    },
                                                    "&": {
                                                        borderColor:
                                                            "#d2ddec",
                                                        boxShadow: "none"
                                                    }
                                                }),
                                                dropdownIndicator: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                }),
                                                singleValue: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                })
                                            }}
                                            name="jobNiche_id"
                                            placeholder="Select"
                                            isMulti={true}
                                            value={this.state.jobNicheList.filter(
                                                item => {
                                                    const temp = this.state.item.jobNiche_id.map(
                                                        item => item.topic_id
                                                    );
                                                    return (
                                                        temp.indexOf(item.id) >= 0
                                                    );
                                                }
                                            )}
                                            onChange={
                                                this
                                                    .handleJobNicheSelectChange
                                            }
                                            options={
                                                this.state.jobNicheList
                                            }
                                        ></Select>
                                        {this.state.errors.jobNiche_id ? (
                                            <div className="invalid-feedback">
                                                The topic field is
                                                required.
                                            </div>
                                        ) : null}
                                    </div>

                                    <div className="form-group mb-4">
                                        <label htmlFor="skills">Skills</label>
                                        <small className="form-text text-muted">What writing skills should the writer(s) ideally have?</small>
                                        <Select
                                            styles={{
                                                control: base => ({
                                                    ...base,
                                                    "&:hover": {
                                                        borderColor:
                                                            "#1cd2ad",
                                                        boxShadow: "none"
                                                    },
                                                    "&": {
                                                        borderColor:
                                                            "#d2ddec",
                                                        boxShadow: "none"
                                                    }
                                                }),
                                                dropdownIndicator: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                }),
                                                singleValue: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                })
                                            }}
                                            name="skill_id"
                                            id="skill_id"
                                            isMulti={true}
                                            placeholder="Select"
                                            onChange={
                                                this
                                                    .handleSkillSelectChange
                                            }
                                            options={
                                                this.state.skillList
                                            }
                                            value={this.state.skillList.filter(
                                                item => {
                                                    const temp = this.state.item.skill_id.map(
                                                        item => item.skill_id
                                                    );
                                                    return (
                                                        temp.indexOf(item.id) >= 0
                                                    );
                                                }
                                            )}
                                        ></Select>
                                        {this.state.errors.skill_id ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.skill_id}
                                            </div>
                                        ) : null} 

                                    </div>


                                    <div
                                        className="form-group mb-4"
                                        data-select2-id="84"
                                    >
                                        <label>Content Types</label>
                                       
                                        <small className="form-text text-muted">What types of content will the writer(s) create?</small>
                                        <Select
                                            styles={{
                                                control: base => ({
                                                    ...base,
                                                    "&:hover": {
                                                        borderColor:
                                                            "#1cd2ad",
                                                        boxShadow: "none"
                                                    },
                                                    "&": {
                                                        borderColor:
                                                            "#d2ddec",
                                                        boxShadow: "none"
                                                    }
                                                }),
                                                dropdownIndicator: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                }),
                                                singleValue: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                })
                                            }}
                                            name="category_id"
                                            value={this.state.jobCategoryList.filter(
                                                item => {
                                                    const temp = this.state.item.category_id.map(
                                                        item => item.category_id
                                                    );
                                                    return (
                                                        temp.indexOf(item.id) >= 0
                                                    );
                                                }
                                            )}
                                            isMulti={true}
                                            placeholder="Select"
                                            onChange={
                                                this
                                                    .handleCategorySelectChange
                                            }
                                            options={
                                                this.state.jobCategoryList
                                            }
                                        ></Select>
                                        {this.state.errors.category_id ? (
                                            <div className="invalid-feedback">
                                                The writer role field
                                                is required.
                                            </div>
                                        ) : null}
                                    </div>

                                    <div className="form-group row">
                                        <div className="col-12 col-md-6">
                                        
                                            <div className="form-group">
                                                <label htmlFor="payout">
                                                    Ave. Per-Article Payout
                                                    (USD)
                                                </label>
                                                <div className="input-group mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text">$</span>
                                                    </div>
                                                    <input
                                                        id="payout"
                                                        name="payout"
                                                        onChange={this.onChange}
                                                        type="number"
                                                        value={
                                                            this.state.item.payout || ''
                                                        }
                                                        className="form-control"
                                                    />
                                                </div>
                                                
                                                {this.state.errors.payout ? (
                                                    <div className="invalid-feedback">
                                                        {
                                                            this.state.errors
                                                                .payout
                                                        }
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="word_count">
                                                    Ave. Words Per Article
                                                </label>
                                                <input
                                                    name="word_count"
                                                    id="word_count"
                                                    onChange={this.onChange}
                                                    value={
                                                        this.state.item.word_count || ''
                                                    }
                                                    type="number"
                                                    className="form-control"
                                                />
                                                {this.state.errors
                                                    .word_count ? (
                                                    <div className="invalid-feedback">
                                                        {
                                                            this.state.errors
                                                                .word_count
                                                        }
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="row">
                                        <div
                                            className="col-sm-6 form-group m-form__group"
                                            data-select2-id="101"
                                        >
                                            <label>Employment Type</label>
                                            <Select defaultValue={{ label: "Select", value: "" }}
                                                styles={{
                                                    control: base => ({
                                                        ...base,
                                                        "&:hover": {
                                                            borderColor:
                                                                "#1cd2ad",
                                                            boxShadow: "none"
                                                        },
                                                        "&": {
                                                            borderColor:
                                                                "#d2ddec",
                                                            boxShadow: "none"
                                                        }
                                                    }),
                                                    dropdownIndicator: base => ({
                                                        ...base,
                                                        color: "inherit"
                                                    }),
                                                    singleValue: base => ({
                                                        ...base,
                                                        color: "inherit"
                                                    })
                                                }}
                                                name="type_id"
                                                value={this.state.typeList.filter(
                                                    item => {
                                                        return (
                                                            item.id ===
                                                            this.state
                                                                .item
                                                                .type_id
                                                        );
                                                    }
                                                )}
                                                placeholder="Select"                                                
                                                onChange={
                                                    this.handleTypeSelectChange
                                                }
                                                options={this.state.typeList}
                                            ></Select>
                                            {this.state.errors.type_id ? (
                                                <div className="invalid-feedback">
                                                    The employment type field is required.
                                                </div>
                                            ) : null}
                                        </div>
                                        <div
                                            className="col-sm-6 form-group m-form__group"
                                            data-select2-id="94"
                                        >
                                            <label>Employment Duration</label>
                                            <Select defaultValue={{ label: "Select", value: "" }}
                                                styles={{
                                                    control: base => ({
                                                        ...base,
                                                        "&:hover": {
                                                            borderColor:
                                                                "#1cd2ad",
                                                            boxShadow: "none"
                                                        },
                                                        "&": {
                                                            borderColor:
                                                                "#d2ddec",
                                                            boxShadow: "none"
                                                        }
                                                    }),
                                                    dropdownIndicator: base => ({
                                                        ...base,
                                                        color: "inherit"
                                                    }),
                                                    singleValue: base => ({
                                                        ...base,
                                                        color: "inherit"
                                                    })
                                                }}
                                                name="duration_id"
                                                placeholder="Select"
                                                value={this.state.jobDurationList.filter(
                                                    item => {
                                                        return (
                                                            item.id ===
                                                            this.state
                                                                .item
                                                                .duration_id
                                                        );
                                                    }
                                                )}
                                                onChange={
                                                    this
                                                        .handleDurationSelectChange
                                                }
                                                options={
                                                    this.state.jobDurationList
                                                }
                                            ></Select>
                                            {this.state.errors.duration_id ? (
                                                <div className="invalid-feedback">
                                                    The employer duration field is
                                                    required.
                                                </div>
                                            ) : null}
                                        </div>
                                        <div
                                            className="col-sm-6 form-group m-form__group"
                                            data-select2-id="94"
                                        >
                                            <label>Employment Location</label>
                                            <Select defaultValue={{ label: "Select", value: "" }}
                                                styles={{
                                                    control: base => ({
                                                        ...base,
                                                        "&:hover": {
                                                            borderColor:
                                                                "#1cd2ad",
                                                            boxShadow: "none"
                                                        },
                                                        "&": {
                                                            borderColor:
                                                                "#d2ddec",
                                                            boxShadow: "none"
                                                        }
                                                    }),
                                                    dropdownIndicator: base => ({
                                                        ...base,
                                                        color: "inherit"
                                                    }),
                                                    singleValue: base => ({
                                                        ...base,
                                                        color: "inherit"
                                                    })
                                                }}
                                                name="location"
                                                id="location"
                                                onChange={
                                                    this
                                                        .handleempLocationChange
                                                }
                                                value={this.state.empLocationList.filter(
                                                    item => {
                                                        return (
                                                            item.id ==
                                                            this.state
                                                                .item
                                                                .location
                                                        );
                                                    }
                                                )}
                                                options={
                                                    this.state.empLocationList
                                                }
                                            ></Select>
                                            {this.state.errors.location ? (
                                                <div className="invalid-feedback">
                                                    The employment location field is
                                                    required.
                                                </div>
                                            ) : null}
                                        </div>
                                        <div className="col-sm-6 form-group m-form__group">
                                            <label htmlFor="spots">
                                                Spots Available
                                            </label>
                                            <Select defaultValue={{ label: "Select", value: "" }}
                                                styles={{
                                                    control: base => ({
                                                        ...base,
                                                        "&:hover": {
                                                            borderColor:
                                                                "#1cd2ad",
                                                            boxShadow: "none"
                                                        },
                                                        "&": {
                                                            borderColor:
                                                                "#d2ddec",
                                                            boxShadow: "none"
                                                        }
                                                    }),
                                                    dropdownIndicator: base => ({
                                                        ...base,
                                                        color: "inherit"
                                                    }),
                                                    singleValue: base => ({
                                                        ...base,
                                                        color: "inherit"
                                                    })
                                                }}
                                                name="spots"
                                                id="spots"
                                                placeholder="Select"
                                                value={this.state.spotList.filter(
                                                    item => {
                                                        return (
                                                            item.id ==
                                                            this.state
                                                                .item
                                                                .spots
                                                        );
                                                    }
                                                )}
                                                
                                                onChange={
                                                    this
                                                        .handlespotChange
                                                }
                                                options={
                                                    this.state.spotList
                                                }
                                            ></Select>
                                            {this.state.errors.spots ? (
                                                <div className="invalid-feedback">
                                                    The spots field is
                                                    required.
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                    { this.state.addExternalEmployerLink ?            
                                    <div className="form-group">
                                        <label htmlFor="title">Apply Source URL</label>
                                        <input
                                            id="source_url"
                                            name="source_url"
                                            onChange={this.onChange}
                                            value={this.state.item.source_url || '' }
                                            type="text"
                                            className="form-control"
                                            placeholder="https://www.jobsource.com/jobs/the-title-of-the-job-listing"
                                        />
                                        {this.state.errors.source_url ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.source_url}
                                            </div>
                                        ) : null}
                                    </div> : null }            
                                    <hr className="mt-5 mb-5" />
                                    
                                    <p className="text-muted mb-4  smaller-text">
                                    { this.state.addExternalEmployerLink ?
                                        `Writers will apply to this job off of ProWriter.`
                                        : `You will receive and manage the writer
                                        applications through your ProWriter
                                        account.` }
                                    </p>
                                    <a
                                        onClick={() =>
                                            this.handleSubmitJob("active")
                                        }
                                        name="save"
                                        className="newJob btn btn-block btn-primary text-white"
                                    >
                                        Update Job Listing
                                    </a>
                                    <div className=" btn-block center-text  mb-4 mt-3 d-flex justify-content-center">
                                        <Link
                                            to={`/admin/job-listings`}
                                            className="btn btn-link text-muted"
                                        >
                                            Cancel this job
                                        </Link>
                                        {/* <a
                                            onClick={() =>
                                                this.handleSubmitJob("saved")
                                            }
                                            className="btn btn-link text-muted"
                                        >
                                            Save as draft
                                        </a> */}
                                    </div>
                                </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Fragment>
                )}
            </Fragment>
        );
    }
}

JobUpdate.contextType = AppContext;
export default JobUpdate;



// WEBPACK FOOTER //
// ./src/components/admin/jobListing/Update.js